import React, {useState, KeyboardEvent} from 'react'
import styles from './EmailTagInput.module.scss'

interface EmailTagInputProps {
  emails: string[]
  onChange: (emails: string[]) => void
  disabled?: boolean
}

const EmailTagInput: React.FC<EmailTagInputProps> = ({emails, onChange, disabled}) => {
  const [inputValue, setInputValue] = useState('')
  const [error, setError] = useState('')

  const validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      addEmail()
    } else if (e.key === 'Backspace' && !inputValue && emails.length > 0) {
      removeEmail(emails.length - 1)
    }
  }

  const addEmail = () => {
    const email = inputValue.trim().replace(/,$/g, '')
    if (!email) return

    if (!validateEmail(email)) {
      setError('Invalid email format')
      return
    }

    if (emails.includes(email)) {
      setError('Email already added')
      return
    }

    onChange([...emails, email])
    setInputValue('')
    setError('')
  }

  const removeEmail = (index: number) => {
    onChange(emails.filter((_, i) => i !== index))
  }

  return (
    <div className={styles.container}>
      <div className={styles.tagsContainer}>
        {emails.map((email, index) => (
          <span key={index} className={styles.tag}>
            {email}
            {!disabled && (
              <button
                type="button"
                onClick={() => removeEmail(index)}
                className={styles.removeBtn}
              >
                ×
              </button>
            )}
          </span>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={addEmail}
          disabled={disabled}
          placeholder={emails.length === 0 ? 'Enter email and press Enter' : ''}
          className={styles.input}
        />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  )
}

export default EmailTagInput
